/**
 * Text color Style
 */
var TextStyle;
(function (TextStyle) {
    TextStyle["PRIMARY"] = "PRIMARY";
    TextStyle["SECONDARY"] = "SECONDARY";
    TextStyle["TERTIARY"] = "TERTIARY";
})(TextStyle || (TextStyle = {}));
/**
 * Returns text's classname depending on text type
 * @param textType {string} - Text type
 * @returns {string} - Text value
 */
export const getTextClassName = (textType) => {
    switch (textType) {
        case 'PRIMARY':
            return 'text-primary';
        case 'SECONDARY':
            return 'text-secondary';
        case 'TERTIARY':
            return 'text-tertiary';
        case 'WHITE':
            return 'text-white';
        case 'GREY':
            return 'text-grey';
        case 'GREY_LIGHT':
            return 'text-grey-light';
        case 'GREY_DARK':
            return 'text-grey-dark';
        case 'SUCCESS':
            return 'text-success';
        case 'WARNING':
            return 'text-warning';
        case 'ERROR':
            return 'text-error';
        case 'INFO':
            return 'text-info';
        default:
            return '';
    }
};
/**
 * Returns text's style depending on text type
 * @param textType {string} - Text type
 * @returns {string} - Text value
 */
export const getTextStyle = (textType) => {
    switch (textType) {
        case 'PRIMARY':
            return '#fe544b';
        case 'SECONDARY':
            return '#109db9';
        case 'TERTIARY':
            return '#25465f';
        default:
            return '';
    }
};
//# sourceMappingURL=Text.js.map